import { render, staticRenderFns } from "./ProfileTurn.vue?vue&type=template&id=2a92bf0e&scoped=true&"
import script from "./ProfileTurn.vue?vue&type=script&lang=js&"
export * from "./ProfileTurn.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTurn.vue?vue&type=style&index=0&id=2a92bf0e&lang=scss&scoped=true&"
import style1 from "./ProfileTurn.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a92bf0e",
  null
  
)

export default component.exports